module.exports={name:"パーガトリーの実験場"};